module.exports = __webpack_public_path__ + "static/media/beau.eafa1b9b.png";